import { lazy } from 'react';

const Carousel = lazy(
	() =>
		import(
			/* webpackChunkName: "carousel" */
			'./carousel.js'
		)
);

export default Carousel;
